<app-header-style-two></app-header-style-two>
<div class="about-area ptb-100">
    <div class="container">
        <div class="row align-items-center">
        
            <div class="col-lg-12 col-md-12">
                <div class="about-content">
                    <h4 style="color: #3b3771;" >{{aboutUsPages?.title}}</h4>
                    <p style="color: white;" [innerHtml]="getSafeHtml(aboutUsPages?.shortText)">
                    </p>
                </div>
            </div>
            <div class="col-lg-12 col-md-12" *ngIf="aboutUsPages?.fullText">
                <div class="about-content"style="color: white;">
                    <p  style="color: white;" [innerHtml]="getSafeHtml(aboutUsPages?.fullText)">
                    </p>
                </div>
            </div>

            <!-- SMS Policy Section for Campaign Compliance -->
            <div class="col-lg-12 col-md-12" style="margin-top: 30px;">
                <div class="about-content" style="color: white;">
                    <h4 style="color: #3b3771;">SMS / Text Messaging Policy</h4>
                    <p style="color: white; font-size: 14px; line-height: 1.8;">
                        <strong style="color: #3b3771;">Consent:</strong> By providing your mobile phone number and checking the SMS consent box on our registration or profile page, you expressly consent to receive text messages (SMS) from Lama Driving School. These messages may include appointment reminders, lesson scheduling updates, instructor notifications, and other service-related communications.
                    </p>
                    <p style="color: white; font-size: 14px; line-height: 1.8;">
                        <strong style="color: #3b3771;">Message Frequency:</strong> Message frequency varies based on your scheduled lessons and account activity.
                    </p>
                    <p style="color: white; font-size: 14px; line-height: 1.8;">
                        <strong style="color: #3b3771;">Rates:</strong> Message and data rates may apply depending on your mobile carrier and plan.
                    </p>
                    <p style="color: white; font-size: 14px; line-height: 1.8;">
                        <strong style="color: #3b3771;">Opt-Out:</strong> You may opt out of SMS messages at any time by replying STOP to any message you receive from us. After opting out, you will receive a single confirmation message and no further SMS messages will be sent.
                    </p>
                    <p style="color: white; font-size: 14px; line-height: 1.8;">
                        <strong style="color: #3b3771;">Help:</strong> For assistance, reply HELP to any message or contact us directly through the website.
                    </p>
                    <p style="color: white; font-size: 14px; line-height: 1.8;">
                        <strong style="color: #3b3771;">Privacy:</strong> SMS opt-in consent and mobile phone numbers collected for SMS purposes will not be shared with or sold to third parties for their marketing purposes.
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>